/* @flow */

import {transformDataForReport} from 'nutshell-core/json-to-report-data';
import type {ActionsObservable} from 'redux-observable';
import {Observable} from 'rxjs';
import {switchMap, map, catchError} from 'rxjs/operators';

import type {WidgetOpensReportDataRequestedAction} from './types';
import {updateReportChartData, failReportChartData} from './widget-opens-actions';

const REST_URL = '/rest/chatwidgetreports/widgetopens';

export const requestWidgetOpensReportDataEpic = (action$: ActionsObservable<*>) =>
    action$.ofType('WIDGET_OPENS_REPORT_DATA_REQUESTED').pipe(
        switchMap((action: WidgetOpensReportDataRequestedAction) => {
            const {reportParams} = action.payload;
            const params = getRequestParams(reportParams);
            const requestStream = Observable.from(fetchData(params));

            return requestStream.pipe(
                map(transformDataForReport),
                map((data) => data.chartData),
                map((chartData) => updateReportChartData({chartData})),
                catchError((err) => Observable.of(failReportChartData(err)))
            );
        })
    );

function fetchData(params) {
    return Promise.all([fetchReportData(params)]);
}

function getRequestParams(reportParams) {
    const {gap, period} = reportParams;

    return {
        gap,
        'filter[period]': period || '-d30',
    };
}

function fetchReportData(params) {
    const ajaxParams = {
        url: REST_URL,
        dataType: 'json',
        data: params,
    };

    return ($.ajax(ajaxParams): any);
}
